<app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
<div class="container">
  @if (type === 'overview') {
    @if (!id) {
      <app-warranty-overview [action]="action"></app-warranty-overview>
    }
  }
  @if (type === 'sendDetails' || type === 'details') {
    @if (type === 'details' && id) {
      <app-warranty-details [id]="id" [add]="add">
        @if (submitted) {
          <ngb-alert type="success">{{'WARRANTY_SENT'|translate}}</ngb-alert>
        }
        @if (submitted) {
          <ngb-alert type="warning">{{'WARRANTY_SENT_INSTRUCTION'|translate}}</ngb-alert>
        }
      </app-warranty-details>
    }
    @if (type !== 'details' && id) {
      <app-warranty-send-details [id]="id" (submitted)="showSubmitted()"></app-warranty-send-details>
    }
  }
  @if (type === 'form') {
    <app-warranty-request-form [type]="'warranty'"></app-warranty-request-form>
  }
  @if (type === 'aftersales') {
    <app-warranty-request-form [type]="'aftersales'"></app-warranty-request-form>
  }
  @if (type === 'crm_overview') {
    <app-warranty-crm-overview></app-warranty-crm-overview>
  }
  @if (type === 'crm_request') {
    <app-warranty-request-crm-form></app-warranty-request-crm-form>
  }
</div>
